export default __webpack_public_path__ + "static/media/rnr-sports-table-22.a44c268d.webp";